import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, AppSelector } from './index';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: AppSelector = useSelector;
